import React, { useContext } from 'react'
import Draggable from 'react-draggable'

import { AppStateContext } from '../AppStateContext'
import Panel from '../../../elem/panel/Panel'
import WellDetailPanelHeader from './WellDetailPanelHeader'
import DataContextProvider from './DataContext'

import { detailPanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
import DetailContent from './DetailContent'

const Detail = () => {
    const { detailState } = useContext(AppStateContext)
    const visible = detailState.well.visible
    return (
        <Draggable bounds="parent" handle=".wellDetailPanelHeader" positionOffset={{x: '.75rem', y: '.75rem'}} >
            <div className={`column is-4-desktop is-half-tablet is-full-mobile detailPanelWrapper ${!visible ? 'is-invisible' : '' }`}>
                <Panel panelClassConfig={panelClassConfig()}>
                    <DataContextProvider>
                        <WellDetailPanelHeader />
                        <div className="wellDetailWrapper">
                            <DetailContent />
                        </div>
                    </DataContextProvider>
                </Panel>
            </div>
        </Draggable>
    )
}

export default Detail
